import { jsxs as t, jsx as e } from "react/jsx-runtime";
const o = ({
  width: a = 80,
  height: r = 80,
  color: n = "green",
  label: l = "audio-loading",
  radius: i = 9
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: a,
    height: r,
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: n,
    "aria-label": l,
    children: [
      /* @__PURE__ */ t("circle", { cx: "15", cy: "15", r: i + 6, children: [
        /* @__PURE__ */ e(
          "animate",
          {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        ),
        /* @__PURE__ */ e(
          "animate",
          {
            attributeName: "fillOpacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        )
      ] }),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "60",
          cy: "15",
          r: i,
          attributeName: "fillOpacity",
          from: "1",
          to: "0.3",
          children: [
            /* @__PURE__ */ e(
              "animate",
              {
                attributeName: "r",
                from: "9",
                to: "9",
                begin: "0s",
                dur: "0.8s",
                values: "9;15;9",
                calcMode: "linear",
                repeatCount: "indefinite"
              }
            ),
            /* @__PURE__ */ e(
              "animate",
              {
                attributeName: "fillOpacity",
                from: "0.5",
                to: "0.5",
                begin: "0s",
                dur: "0.8s",
                values: ".5;1;.5",
                calcMode: "linear",
                repeatCount: "indefinite"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t("circle", { cx: "105", cy: "15", r: i + 6, children: [
        /* @__PURE__ */ e(
          "animate",
          {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        ),
        /* @__PURE__ */ e(
          "animate",
          {
            attributeName: "fillOpacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        )
      ] })
    ]
  }
), s = o;
export {
  s as default
};
